/** zh-CN catalogue `raw` (W3-09; English: src/features/raw/raw.messages.ts; terms: docs/i18n/glossary.md). */
import type { MessageCatalog } from '../../core/util/types';

const PROP =
  '{prop, select, moveX {X 位置} moveY {Y 位置} rotate {旋转} alpha {不透明度} speed {流速} scaleX {长度 / X 尺寸} scaleY {粗细 / Y 尺寸} color {颜色} text {文字} incline {倾斜} paint {画笔} gif {GIF 进度} other {{prop}}}';

const catalog: MessageCatalog = {
  ns: 'raw',
  locale: 'zh-CN',
  messages: {
    panelTitle: '原始数据',
    regionLabel: '选中内容的原始 JSON',
    subtitle: '导出时为选中内容写入的确切内容',
    showLabel: '显示',
    targetEvents: `${PROP}事件 · 层级 {layer} · {line}`,
    targetEventsExt: `${PROP}事件 · {line}`,
    targetNotes: '{count, plural, other {# 个音符}} · {line}',
    targetLine: '判定线字段 · {line}',
    targetControls:
      '距离控制：{which, select, pos {X 位置} alpha {不透明度} size {尺寸} y {Y 位置} other {{which}}} · {line}',
    emptyTitle: '没有可显示的内容',
    emptyBody: '选中音符、关键帧或区段，或激活一条判定线，即可查看导出时为它写入的 JSON。',
    emptyAbsent: '导出时已不再为此选中内容写入任何内容。',
    controlAbsent: '未设置：Phira 使用系数 1。写入控制点即可设置。',
    editorLabel: 'RPE JSON',
    schemaOk: '结构：正常',
    schemaProblems: '结构：{count, plural, other {# 个问题}}',
    schemaWarnings: '结构：正常，{count, plural, other {# 条提示}}',
    unchanged: '未更改',
    edited: '已编辑',
    apply: '应用',
    applyHint: '应用（Ctrl+Enter）',
    revert: '还原',
    copy: '复制为 RPE JSON',
    copied: '已复制 {target} 的 RPE JSON。',
    copyFailed: '剪贴板未接受该文本：{reason}',
    pretty: '缩进',
    compact: '紧凑',
    formatLabel: '排版',
    viewJson: 'JSON',
    viewTable: '事件表',
    viewLabel: '视图',
    footnote: '编辑内容会像导入一样被读取、检查、提升，并作为一个可撤销的步骤应用。不会悄悄修复任何内容。',
    bakedNote: '旧版流速模式会把带缓动的流速写为直线分段。应用此文本会用这些分段替换曲线。',
    useCorrected: '显示更正后的版本',
    correctedHint: 'Phira 会以不同方式读取此内容。请检查更正后的文本，然后应用。',
    goToProblem: '转到 {path}',
    problemAt: '{path}：{message}',
    problemWhole: '{message}',
    problemsLabel: '问题',
    selectionChanged: '编辑期间选中内容已改变。',
    showSelection: '放弃编辑并显示选中内容',
    docChanged: '开始编辑后谱面已改变。',
    reload: '放弃编辑并重新加载',
    applied: '已应用原始 JSON：{count, plural, =0 {没有任何更改} other {# 处更改}}。',
    appliedNothing: '没有可应用的内容：该 JSON 与导出时写入的内容相同。',
    txApply: '编辑原始 JSON：{target}',
    tableLabel: '{target} 的事件',
    colIndex: '#',
    colStart: '开始',
    colEnd: '结束',
    colFrom: '起始值',
    colTo: '结束值',
    colEasing: '缓动',
    colSlice: '部分',
    colBezier: '贝塞尔',
    colLink: '绑定',
    colOrigin: '写入原因',
    sliceWhole: '整条',
    bezierNone: '否',
    linkNone: '-',
    origin:
      '{origin, select, segment {区段} single {单个关键帧} trailing {结尾跳变} lead {开头} padding {RPE 填充} bakePiece {烘焙分段} other {{origin}}}',
    eventCount: '{count, plural, other {# 个事件}}',
    revealEvent: '转到事件 {index} 所在的区段',
    eventSkipped: '事件 {at} 无法使用：其时间无效、结束早于开始，或开始早于上一个事件。',
    notesCount: '列表必须正好保留 {count, plural, other {# 个音符}}。请改在轨道中添加或删除音符。',
    fileMissing: '此项目中没有名为“{path}”的文件。',
    holdEnd: 'Hold 的结束必须晚于开始。',
    fatherInvalid: '“father”必须是 -1（没有父线）或另一条判定线的序号（0 到 {max}）。',
    groupInvalid: '“Group” {group} 不是此谱面的判定线分组。',
    rederived: '“isGif”和“numOfNotes”在导出时计算：编辑后的值不会保留。',
    notRepresentable: '无法应用此文本：列表为空，或其中没有谱面能容纳的内容。',
    kindMismatch: '此文本属于另一种项目。',
    targetGone: '此文本所属的项目已不存在。',
    noProject: '请先打开一个项目。',
    noTarget: '请先选中音符、关键帧、区段或判定线。',
    panelClosed: '请打开“原始数据”选项卡来编辑 JSON。',
    cmdShow: '显示原始 JSON',
    cmdApply: '应用原始 JSON',
    cmdRevert: '还原原始 JSON',
    cmdCopy: '将选中内容复制为 RPE JSON',
    cmdFormat: '原始 JSON：紧凑排版',
    settingCompact: '原始数据面板：紧凑 JSON',
    settingCompactHelp: '像导出时一样把原始数据面板中的 JSON 写在少数几行中，而不是缩进排版。',
    settingShortest: '原始数据面板：最短数字',
    settingShortestHelp: '小数字段中的整数尽可能写短（1），而不是像 RPE 那样（1.0）。',
    helpTitle: '原始 JSON',
    helpBody:
      '“原始数据”选项卡（完整模式）显示导出时为所选内容写入的 RPE JSON：一条轨道的事件、音符、判定线自身的字段或距离控制曲线。编辑后按 Ctrl+Enter 应用：文本会像导入一样被读取，每个问题都会连同其在 JSON 中的位置列出，不会在你看不到的情况下修复任何内容。事件表列出一条轨道的每个事件及其缓动、曲线部分、贝塞尔和绑定组；“复制为 RPE JSON”可将其复制到 RPE 或其他工具中使用。',
  },
};

export default catalog;
